import React from "react";
import {Authenticator, translations} from '@aws-amplify/ui-react';
import {Amplify, I18n} from "aws-amplify";
import {createBrowserRouter, RouterProvider} from "react-router-dom";

import routes from './config/routes';
import {i18nTranslations} from "./config/authenticatorOptions";
import awsExports from "./config/aws-exports";

import '@aws-amplify/ui-react/styles.css';


I18n.putVocabularies(translations);
I18n.setLanguage('it');
I18n.putVocabularies(i18nTranslations);

Amplify.configure(awsExports);

const router = createBrowserRouter(routes);

const App = () => {
  return (
    <Authenticator.Provider>
      <RouterProvider router={router}/>
    </Authenticator.Provider>
  );
}

export default App;